module.exports = __webpack_public_path__ + "static/course_buyed.90777f57.png";